var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_38",
    "data-name": "Group 38",
    xmlns: "http://www.w3.org/2000/svg",
    width: 180.048,
    height: 130.607,
    viewBox: "0 0 180.048 130.607",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M140.083,84.462l39.965,23.072-39.965,23.072V115.774c-34.4,0-53.767-18.746-70.041-37.7C53.767,97.028,34.4,115.774,0,115.774V99.294c28.429,0,43.673-15.244,59.329-33.991C43.673,46.557,28.429,31.313,0,31.313V14.832c34.4,0,53.767,18.746,70.041,37.7,16.274-18.952,35.639-37.7,70.041-37.7V0l39.965,23.072L140.083,46.145V31.313c-28.429,0-43.673,15.244-59.329,33.991C96.41,84.05,111.448,99.294,140.083,99.294Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/change.c4c43195034f6baf28e9575de18a29bc.svg";
export { ForwardRef as ReactComponent };